import Swiper from 'swiper'
import {Navigation, Pagination} from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/pagination'

export default class StudiesSlider {
    private sliders: NodeListOf<HTMLElement>

    constructor() {
        this.sliders = document.querySelectorAll('.studies-slider')
        this.init()
    }

    private init() {
        for (const slider of this.sliders) {
            const swiper = new Swiper(slider.querySelector('.swiper') as HTMLElement, {
                modules: [Navigation, Pagination],
                slidesPerView: 1.15,
                spaceBetween: 24,
                rewind: true,
                watchOverflow: true,
                navigation: {
                    nextEl: slider.querySelector<HTMLButtonElement>('.swiper-button-next'),
                    prevEl: slider.querySelector<HTMLButtonElement>('.swiper-button-prev'),
                },
                pagination: {
                    el: slider.querySelector<HTMLDivElement>('.swiper-pagination'),
                    clickable: true,
                    dynamicBullets: true,
                },
                breakpoints: {
                    768: {slidesPerView: 2, spaceBetween: 32},
                    1024: {slidesPerView: 3, spaceBetween: 48},
                },
            })

            // watchOverflow disables sliding per breakpoint when the slides fit
            // (e.g. 3 items on desktop); hide the controls when that happens.
            const syncLocked = () =>
                slider.classList.toggle('studies-slider--locked', swiper.isLocked)
            swiper.on('lock', syncLocked)
            swiper.on('unlock', syncLocked)
            syncLocked()
        }
    }
}
